<div class="pageWrapper indirect_material">
  <!-- <h3>Indirect Material</h3> -->

  <!-- <div class="row">
    <div class="col-sm-3">
      <ul *ngFor="let cat of categories">
        <li>
          <a routerLink="/rfq/indirect-material">{{ cat.name }}</a>
          <ul>
            <li></li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="com-sm-9">
      <div class="row">
        <div class="col-sm-3" *ngFor="let product of products">
          <mat-card class="example-card flex mrb">
            <img mat-card-image src="{{ product?.base_image?.large_image_url }}" alt="" />
            <mat-card-header>
               <div mat-card-avatar class="example-header-image"></div> 
              <mat-card-title>{{ product?.name }}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <p>{{ product?.description }}</p>
            </mat-card-content>
            <mat-card-actions>
              <button mat-button>SKU : {{ product?.sku }}</button>
              <button mat-flat-button routerLink="/rfq/create-rfq" class="create-rfq-btn">Create RFQ</button>
            </mat-card-actions>
          </mat-card>
        </div>
      </div>
    </div>
  </div> -->

  <div class="col-sm-12">
    <div class="flex">
      <!-- <div class="col-sm-3">
        <div class="nav">
          <h3>Categories</h3>
          <div class="menu-container">
            <ul class="menu">
              <ng-container *ngFor="let cat of categories">
                <li *ngIf="cat.parent_id == 1" (click)="toggleSubmenu(cat)">
                  <a>
                    <span class="flex parent">
                      {{ cat.name }}
                      <span class="icon" [ngClass]="{ rotated: cat.open }">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-chevron-right"
                        >
                          <path d="m9 18 6-6-6-6"></path>
                        </svg>
                      </span>
                    </span>

                    <ul class="submenu" [ngClass]="{ open: cat.open }">
                      <li *ngIf="cat.parent_id == cat.id">
                        <a (click)="getIndirectMaterial(cat.id)">sadsad{{ cat.name }}</a>
                      </li>
                    </ul>
                  </a>
                </li>
              </ng-container>
              <li *ngFor="let cat of categories" (click)="toggleSubmenu(cat); getIndirectMaterial(cat.id)">
                <a (click)="getIndirectMaterial(cat.id)">
                  <span class="flex parent">
                    {{ cat.name }}
                    <span class="icon" [ngClass]="{ rotated: cat.open }">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-chevron-right"
                      >
                        <path d="m9 18 6-6-6-6"></path>
                      </svg>
                    </span>
                  </span>

                  <ul class="submenu" [ngClass]="{ open: cat.open }">
                    <li *ngIf="cat.parent_id == cat.id">
                      <a (click)="getIndirectMaterial(cat.id)">{{ cat.name }}</a>
                    </li>
                  </ul>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div> -->

      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab label="Indirect">
          <div class="row">
            <div class="col-sm-3" *ngFor="let product of products">
              <mat-card class="example-card flex mrb">
                <img mat-card-image src="{{ product?.base_image?.large_image_url }}" alt="" />
                <mat-card-header>
                  <!-- <div mat-card-avatar class="example-header-image"></div> -->
                  <mat-card-title>{{ product?.name }}</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="product-description">{{ product?.description }}</p>
                </mat-card-content>
                <mat-card-actions>
                  <button mat-button>SKU : {{ product?.sku }}</button>
                  <button mat-flat-button routerLink="/rfq/create-rfq" class="create-rfq-btn">Raise RFQ</button>
                </mat-card-actions>
              </mat-card>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Capital Equipment">
          <div class="row">
            <div class="col-sm-3" *ngFor="let product of products">
              <mat-card class="example-card flex mrb">
                <img mat-card-image src="{{ product?.base_image?.large_image_url }}" alt="" />
                <mat-card-header>
                  <!-- <div mat-card-avatar class="example-header-image"></div> -->
                  <mat-card-title>{{ product?.name }}</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="product-description">{{ product?.description }}</p>
                </mat-card-content>
                <mat-card-actions>
                  <button mat-button>SKU : {{ product?.sku }}</button>

                  <button mat-flat-button routerLink="/rfq/create-rfq" class="create-rfq-btn">Raise RFQ</button>
                </mat-card-actions>
              </mat-card>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
